import { api } from '../core';

export interface ToolGroupOption {
  groupId: string;
  groupName: string;
}

export interface ToolGroupCollectionResponse {
  collections: ToolGroupCollectionOption[];
}

export interface ToolGroupCollectionOption {
  collectionId: string;
  collectionName: string;
  groups: ToolGroupOption[];
}

const getToolGroupCollectionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getToolGroupCollections: builder.query<ToolGroupCollectionResponse, void>({
      query: () => ({
        url: 'toolkit/tool-group-collections',
        method: 'GET',
      }),
      extraOptions: { maxRetries: 3 },
    }),
  }),
});

export const { useGetToolGroupCollectionsQuery } = getToolGroupCollectionsApi;
